<template>
  <div class="question">
      <b-input v-model="name" placeholder="名前を入力ください"></b-input>
      <b-input v-model="title" placeholder="夢のタイトル">タイトル</b-input>
      <b-input v-model="content">内容</b-input>
      <b-button @click="send">送る</b-button>
  </div>
</template>

<script>
import firebase from '@firebase/app'
export default {
  name: 'question',
  data(){
    return{
        uid: '',
        name: '',
        title:null,
        content:null
    }
  },
  created(){
    firebase.auth().signInAnonymously().catch(function(error) {
      // var errorCode = error.code;
      // var errorMessage = error.message;
      console.log(error.messsage)
    }).then(()=>{
      var self = this;
      firebase.auth().onAuthStateChanged(function(user) {
        if (user) {
          self.uid = user.uid;
        } else {
          console.log("err")
        }
      });
    });
  },
  mounted(){
    const title = "質問画面｜夢占い辞典ゆめみん"
    const description = "夢占い辞典ゆめみんの質問画面"
    document.title = title
    document.querySelector("meta[property='og:title']").setAttribute('content', title)
    document.querySelector("meta[name='description']").setAttribute('content', description)
    document.querySelector("meta[property='og:description']").setAttribute('content', description)
  }, 
    methods:{
        send(){
            var new_doc_Id = firebase.firestore().collection("questions").doc();
            firebase.firestore().collection('user').doc().set({
                uid: this.uid,
            }).then(()=>{
                new_doc_Id.set({
                    uid: this.uid,
                    doc_id: new_doc_Id,
                    name: this.name,
                    title: this.title,
                    content: this.content
                });
            });        
        }
    }
}
</script>

<style scoped>
.entry{
  max-width: 520px;
  margin:auto;
  padding: 10px;
}
h1{
  font-size: 2.2em;
  color:#7956D5;
  font-family: Nikukyu;
  margin-bottom:10px;
}
h2{
  font-weight: bold;
  font-size: 1.2em;
  padding:10px;
}
h3{
  font-weight: bold;
  font-size: 1.2em;
  padding:10px;
}
p{
  padding: 10px;
}
.how_to{
  padding-top: 20px;
}
</style>